var $b61325f242fafc7c$exports = {};
$b61325f242fafc7c$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `V\xfdber farieb`,
    "colorSwatch": `vzorkovn\xedk farieb`,
    "transparent": `transparentn\xfd`,
    "twoDimensionalSlider": `2D jazdec`
};


export {$b61325f242fafc7c$exports as default};
//# sourceMappingURL=sk-SK.module.js.map
